import { Info } from '@nexus/lib-react/dist/core/Icon/icons/default';
import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import mq from '../../../../../commons/styles/mediaQueries';
import { progressiveLoading } from '../../../../../commons/styles/animations';
import styled from '../../../../../theme/styled';

const StatusInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.space[16]};
  padding: 0 ${({ theme }) => theme.space[16]};

  ${mq.desktop} {
    margin-bottom: ${({ theme }) => theme.space[24]};
    padding: 0;
  }
`;

const StatusInfoText = styled(Paragraph4)`
  margin-left: 10px;
  font-size: ${({ theme }) => theme.fontSizes[12]};
  color: ${({ theme }) => theme.colors['text-global-secondary']};
`;

const StatusLoading = styled.div`
  ${progressiveLoading()}
  padding: 18px;
  width: 100%;
`;

const InfoIcon = styled(Info)`
  height: ${({ theme }) => theme.sizes[16]};
  width: ${({ theme }) => theme.sizes[16]};
  color: ${({ theme }) => theme.colors['text-global-secondary']};
`;

export default {
  StatusInfo,
  StatusInfoText,
  StatusLoading,
  InfoIcon,
};
